import { Box, Typography } from "@mui/material";
import React from "react";

const EndMessage = (): React.JSX.Element => (
  <Box sx={{ pt: 6 }}>
    <Typography
      variant="body1"
      color="initial"
      sx={{
        mb: 1,
        fontWeight: "bold",
        color: (theme) => theme.palette.primary.main,
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      Über einen AVGS ist auch eine intensivere Coachingbegleitung möglich.
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{ mb: 1, textAlign: { xs: "center", sm: "left" } }}
    >
      Du hast die positive Kraft von Coaching kennengelernt? Du möchtest
      Coaching noch stärker für dich nutzen?
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{ textAlign: { xs: "center", sm: "left" } }}
    >
      Erkundige dich bei unseren Kolleg:innen vor Ort, direkt bei der Agentur
      für Arbeit oder deinem Jobcenter nach einem AVGS (Aktivierungs- und
      Vermittlungsgutschein), mit dem auch umfangreichere Coachings gefördert
      werden können.
    </Typography>
  </Box>
);

export default EndMessage;
